import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';
import { useGetV8ExtraServerGet } from '@/api-client/metav8Over/queries/extra-v8-controller/extra-v8-controller';
import { FRAME_NAMES } from '@/common/define/apiTrace.define';
import { getRegisteredExternalResourceTypes } from '@/dashboard/shared/utils/externalResource.utils';

export const useRegisteredExternalResourceTypes = (enabled: MaybeRef<boolean> = true) => {
  const query = useGetV8ExtraServerGet({
    query: {
      enabled: computed(() => unref(enabled)),
      select: (response) => getRegisteredExternalResourceTypes(response.data?.data),
    },
    request: {
      params: {
        frameName: FRAME_NAMES.DASHBOARD.EXTRA_SERVER_LIST,
      },
    },
  });

  const registeredExternalResourceTypes = computed(() => {
    return query.data.value ?? [];
  });

  return {
    ...query,
    registeredExternalResourceTypes,
  };
};
